import { useState } from 'react'
import { Link } from 'react-router-dom'
import { User } from '../../types'
import AdminViewAsSelect from './AdminViewAsSelect'

interface MobileMenuProps {
  user: User | null
  isAdmin: boolean
  showEarlySignals?: boolean
  showSimpleHq?: boolean
  onSignIn: () => void
  onSignOut: () => Promise<void>
  onAdminClick: () => void
  onChangePassword?: () => void
}

const MobileMenu = ({ user, isAdmin, showEarlySignals, showSimpleHq, onSignIn, onSignOut, onAdminClick, onChangePassword }: MobileMenuProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  const handleLinkClick = () => {
    setIsOpen(false)
  }

  return (
    <>
      <div className="md:hidden flex items-center">
        <button
          onClick={toggleMenu}
          className="text-gray-500 hover:text-black focus:outline-none p-2"
        >
          <i className={`fa-solid ${isOpen ? 'fa-xmark' : 'fa-bars'} text-xl`}></i>
        </button>
      </div>

      {isOpen && (
        <div className="md:hidden absolute top-20 left-0 w-full bg-white border-b border-gray-100 shadow-lg">
          <div className="px-4 pt-2 pb-6 space-y-2">
            <Link
              to="/"
              onClick={handleLinkClick}
              className="block px-3 py-3 text-base font-medium text-gray-900 hover:bg-gray-50 rounded-md"
            >
              Home
            </Link>
            <a
              href="#about"
              onClick={handleLinkClick}
              className="block px-3 py-3 text-base font-medium text-gray-600 hover:text-black hover:bg-gray-50 rounded-md"
            >
              About Us
            </a>
            <a
              href="#stack"
              onClick={handleLinkClick}
              className="block px-3 py-3 text-base font-medium text-gray-600 hover:text-black hover:bg-gray-50 rounded-md"
            >
              The Simple Stack
            </a>
            <a
              href="#industries"
              onClick={handleLinkClick}
              className="block px-3 py-3 text-base font-medium text-gray-600 hover:text-black hover:bg-gray-50 rounded-md"
            >
              Industries
            </a>
            <a
              href="#faq"
              onClick={handleLinkClick}
              className="block px-3 py-3 text-base font-medium text-gray-600 hover:text-black hover:bg-gray-50 rounded-md"
            >
              FAQ
            </a>
            <a
              href="#contact"
              onClick={handleLinkClick}
              className="block px-3 py-3 text-base font-medium text-gray-600 hover:text-black hover:bg-gray-50 rounded-md"
            >
              Contact
            </a>
            <a
              href="#executive-briefings"
              onClick={handleLinkClick}
              className="block px-3 py-3 text-base font-medium text-gray-600 hover:text-black hover:bg-gray-50 rounded-md"
            >
              Newsletter
            </a>
            {showEarlySignals && (
              <Link
                to="/early-signals"
                onClick={handleLinkClick}
                className="block px-3 py-3 text-base font-medium text-gray-600 hover:text-black hover:bg-gray-50 rounded-md"
              >
                Early Signals
              </Link>
            )}
            {showSimpleHq && (
              <Link
                to="/simple-hq"
                onClick={handleLinkClick}
                className="block px-3 py-3 text-base font-medium text-teal-800 hover:text-teal-900 hover:bg-teal-50 rounded-md"
              >
                Simple HQ
              </Link>
            )}
            {isAdmin && (
              <div className="px-3 py-2">
                <AdminViewAsSelect variant="navbar" />
              </div>
            )}
            {isAdmin && (
              <button
                onClick={() => {
                  onAdminClick()
                  handleLinkClick()
                }}
                className="w-full text-left block px-3 py-3 text-base text-blue-600 hover:bg-blue-50 rounded-md font-bold"
              >
                <i className="fa-solid fa-shield-halved mr-2"></i>Admin dashboard
              </button>
            )}
            <div className="pt-4 border-t border-gray-100 mt-2">
              {!user ? (
                <button
                  onClick={() => {
                    onSignIn()
                    handleLinkClick()
                  }}
                  className="w-full text-left block px-3 py-3 text-base font-medium text-blue-600 hover:bg-blue-50 rounded-md"
                >
                  Sign In
                </button>
              ) : (
                <>
                  {onChangePassword && (
                    <button
                      onClick={() => {
                        onChangePassword()
                        handleLinkClick()
                      }}
                      className="w-full text-left block px-3 py-3 text-base font-medium text-gray-600 hover:bg-gray-50 rounded-md"
                    >
                      Change password
                    </button>
                  )}
                  <button
                    onClick={async () => {
                      try {
                        await onSignOut()
                        handleLinkClick() // Close menu after successful sign out
                      } catch (error: any) {
                        console.error('Sign out error:', error)
                        alert(`Failed to sign out: ${error.message || 'Unknown error'}`)
                        // Don't close menu on error so user can try again
                      }
                    }}
                    className="w-full text-left block px-3 py-3 text-base font-medium text-red-600 hover:bg-red-50 rounded-md"
                  >
                    Sign Out
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default MobileMenu
